import tmsMdmAxiosInstance from '@/tms-mdm-axios';

const actions = {

  async list({ commit }) {
    try {
      commit('ROLES_LOADING', true);
      const result = await tmsMdmAxiosInstance('/role');
      if (result && result.data) {
        commit('ROLES_DATA', result.data);
      }
      return result && result.data;
    } catch (err) {
      return err;
    } finally {
      commit('ROLES_LOADING', false);
    }
  },

};

export default actions;
